// Filtres et tris d'un tableau dont toutes les lignes sont déjà chargées : le service renvoie la liste complète du groupe (quelques dizaines
// de lignes), la recherche, les filtres avancés et les tris de CustomTable s'appliquent donc ici et non sur le serveur.
// filters : [{field, operator, variable}] (EQUAL, GREATER_THAN, MINUS_THAN, IN, NOT_IN), sorts : [{field, order}] (ASCENDING, DESCENDING)

const DAY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}T/;

const normalize = value => String(value).normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// Valeur d'un champ, éventuellement imbriqué (« progress.percent »)
export function valueOf(row, field) {
    return String(field).split('.').reduce((value, key) => (value === undefined || value === null ? undefined : value[key]), row);
}

const isEmpty = value => value === undefined || value === null || value === '';

// Valeur de filtre « sans valeur » : sélectionne les lignes dont le champ est vide (ex. publications importées pas encore classées par intention)
export const UNCLASSIFIED = "UNCLASSIFIED";

// Jour (AAAA-MM-JJ, heure locale) d'une date ISO
function dayOf(value) {
    const date = new Date(value);
    const pad = number => String(number).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function matches(row, filter) {
    const value = valueOf(row, filter.field);
    const variable = filter.variable;

    const isIn = () => (Array.isArray(variable) ? variable : [variable]).some(item => isEmpty(value) ? item === UNCLASSIFIED : String(item) === String(value));
    if (filter.operator === 'IN') return isIn();
    if (filter.operator === 'NOT_IN') return !isIn();
    if (isEmpty(value)) return variable === UNCLASSIFIED && filter.operator !== 'GREATER_THAN' && filter.operator !== 'MINUS_THAN';

    // Une date se compare au jour saisi
    if (typeof value === 'string' && DATE_PATTERN.test(value) && DAY_PATTERN.test(String(variable))) {
        const day = dayOf(value);
        if (filter.operator === 'GREATER_THAN') return day > variable;
        if (filter.operator === 'MINUS_THAN') return day < variable;
        return day === variable;
    }
    if (typeof value === 'number') {
        if (filter.operator === 'GREATER_THAN') return value > Number(variable);
        if (filter.operator === 'MINUS_THAN') return value < Number(variable);
        return value === Number(variable);
    }
    if (filter.operator === 'GREATER_THAN') return normalize(value) > normalize(variable);
    if (filter.operator === 'MINUS_THAN') return normalize(value) < normalize(variable);
    return normalize(value) === normalize(variable) || normalize(value).includes(normalize(variable));
}

function compare(a, b) {
    if (typeof a === 'number' && typeof b === 'number') return a - b;
    if (typeof a === 'string' && DATE_PATTERN.test(a) && typeof b === 'string' && DATE_PATTERN.test(b)) return Date.parse(a) - Date.parse(b);
    return String(a).localeCompare(String(b), 'fr', {sensitivity: 'base', numeric: true});
}

export function queryRows(rows, filters = [], sorts = []) {
    let result = filters.length > 0 ? rows.filter(row => filters.every(filter => matches(row, filter))) : [...rows];
    if (sorts.length > 0) {
        result = result
            .map((row, index) => ({row, index}))
            .sort((first, second) => {
                for (const sort of sorts) {
                    const a = valueOf(first.row, sort.field);
                    const b = valueOf(second.row, sort.field);
                    // Une valeur absente passe toujours après les autres
                    if (isEmpty(a) !== isEmpty(b)) return isEmpty(a) ? 1 : -1;
                    if (isEmpty(a)) continue;
                    const order = compare(a, b);
                    if (order !== 0) return sort.order === 'DESCENDING' ? -order : order;
                }
                return first.index - second.index;
            })
            .map(item => item.row);
    }
    return result;
}
